import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const GudangPage = ({}) => {
  const navigate = useNavigate();

  let menu = [
    {
      auth: "GoodsAcceptance",
      name: "Penerimaan Barang",
      path: "/gudang/transaction/penerimaan-barang",
    },
    {
      auth: "GoodsExpenditure",
      name: "Pengeluaran Barang",
      path: "/gudang/transaction/pengeluaran-barang",
    },
    {
      auth: "GoodsReturn",
      name: "Return Barang",
      path: "/gudang/transaction/return-barang",
    },
    {
      auth: "GoodsAccepteanceUser",
      name: "Penerimaan Barang User",
      path: "/gudang/transaction/penerimaan-barang-user",
    },
    {
      auth: "AdjustmentStock",
      name: "Penyesuaian Stock",
      path: "/gudang/stock/adjust",
    },
    {
      auth: "POTransit",
      name: "PO Transit",
      path: "/gudang/po-transit",
    },
  ];
  let Report = [
    { auth: "GoodsStock", name: "Stock", path: "/gudang/stock" },
    {
      auth: "GoodsPenerimaan",
      name: "Monitoring Penerimaan",
      path: "/gudang/penerimaan",
    },
    {
      auth: "GoodsLapPenerimaan",
      name: "Laporan Penerimaan",
      path: "/gudang/lap-penerimaan",
    },
    {
      auth: "GoodsPengeluaran",
      name: "Monitoring Pengeluaran",
      path: "/gudang/pengeluaran",
    },
    {
      auth: "GoodsLapPengeluaran",
      name: "Laporan Pengeluaran",
      path: "/gudang/lap-pengeluaran",
    },
    // Memakai otoritas Laporan Pengeluaran: datanya sama (pengeluaran barang),
    // jadi tak perlu kolom otoritas baru / login ulang.
    {
      auth: "GoodsLapPengeluaran",
      name: "Fast Moving",
      path: "/gudang/fast-moving",
    },
  ];
  // Grup tersendiri, sengaja TIDAK digabung ke "Report": isinya dibatasi Bagian pengguna,
  // jadi angkanya tak bisa dibandingkan langsung dengan laporan gudang yang lain.
  let ReportBagian = [
    { auth: "GoodsStockBagian", name: "Stock", path: "/gudang/stock-bagian" },
  ];
  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);
  const [listReportBagian, setListReportBagian] = useState(ReportBagian);

  // Header & search bar MenuBuilder dirender tanpa memeriksa otoritas, jadi grup ini
  // disembunyikan di sini — kalau tidak, yang tak punya aksesnya melihat judul kosong.
  const user = JSON.parse(localStorage.getItem("user") || "{}") || {};
  const bolehLihatStockBagian =
    !!user?.Otoritas?.GoodsStockBagian && user.Otoritas.GoodsStockBagian !== 0;

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListMenu(filtered);
  };
  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReport(filtered);
  };
  const filterReportBagian = (event) => {
    const filtered = ReportBagian.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReportBagian(filtered);
  };
  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <MenuBuilder
            name="Transaction"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className={"border border-main-100 my-6"} />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
          {bolehLihatStockBagian && (
            <>
              <hr className={"border border-main-100 my-6"} />
              <MenuBuilder
                name="Report Bagian Saya"
                menuController={filterReportBagian}
                listMenu={listReportBagian}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GudangPage;
